import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  DropdownItem,
} from "reactstrap";
import DatePicker from "react-datepicker";
import { useForm, useController } from "react-hook-form";
import moment from "moment";
import CustomSelect from "../../../CommonElements/CustomSelect";
const FilterForm = (props) => {
  const { register, handleSubmit, control, setValue, watch } = useForm();

  const { field } = useController({ name: "column_name", control });

  const [date, setDate] = useState("");
  const [hasValue, setHasValue] = useState(false);

  const columnsNames = props.options ? props.options : [];

  let column_type;

  switch (field.value?.type) {
    case "date":
      column_type = (
        <DatePicker
          className="form-control"
          selected={date}
          onChange={(date) => {
            setDate(date);
            const formattedDate = moment(new Date(date)).format("YYYY-MM-DD");
            setValue("column_value", formattedDate);
            setHasValue(!!formattedDate);
          }}
          date
          showIcon
          showYearDropdown
          showMonthDropdown
          scrollableYearDropdown
          dateFormat="dd/MM/yyyy"
          shouldCloseOnSelect={true}
        />
      );
      break;
    case "text":
      column_type = (
        <input
          {...register("column_value", {
            onChange: (e) => setHasValue(!!e.target.value)
          })}
          className="form-control"
          type="text"
          placeholder="Enter Value"
        />
      );
      break;
    case "select":
      column_type = (
        <CustomSelect
          className="basic-single"
          classNamePrefix="select"
          isClearable={true}
          isSearchable={true}
          value={columnsNames.find((element) => {
            return element.value == field.value;
          })}
          onChange={(value) => {
            console.log("changed value", value);
            // Store both value and label for select types
            setValue("column_value", value ? { value: value.value, label: value.label } : null);
            setHasValue(value && (value.value !== undefined && value.value !== null && value.value !== ""));
          }}
          options={
            field?.value.value === "current_booking_status_type" ||
            field?.value.value === "current_trip_status_type" ||
            field?.value.value === "current_car_status" ||
            field?.value.value === "status" ||
            field?.value.value === "currentBookingStatusType" ||
            field?.value.value === "procurementStatus"? props.statusData
              : field?.value.value === "pickup_type"
              ? props.pickupTypeData
              : field?.value.value === "carTypeId"
              ? props.carTypeData
              : field?.value.value === "aggregatorId"
              ? props.aggregatorData
              : field?.value.value === "booking_via_type" 
              ? props.bookingViaTypeData
              : field?.value.value === "rideType"
              ? props.rideTypeData
              : field?.value.value === "bookingSource"
              ? props.bookingSourceData
              : field?.value.value === "client_type"
              ? props.clientTypeData
              : field?.value.value === "terminal"
              ? props.terminalData
              : []
            
          }
        />
      );
      break;
    case "boolean":
      column_type = (
        <CustomSelect
          className="basic-single"
          classNamePrefix="select"
          isClearable={true}
          isSearchable={true}
          value={columnsNames.find((element) => {
            return element.value == field.value;
          })}
          onChange={(value) => {
            console.log("changed value", value);
            setValue("column_value", value?.value);
            setHasValue(value && (value.value === true || value.value === false));
          }}
          options={[
            { label: "True", value: true },
            { label: "False", value: false },
          ]}
        />
      );
      break;
    default:
      column_type = (
        <input
          {...register("column_value", {
            onChange: (e) => setHasValue(!!e.target.value)
          })}
          className="form-control"
          type="text"
          placeholder="Enter Value"
        />
      );
      break;
  }

  const onsubmitdata = (formValues) => {
    // Validate that both column name and value are selected
    if (!formValues.column_name || formValues.column_value === undefined || formValues.column_value === null || formValues.column_value === "") {
      console.log("Please select both filter category and value");
      return; // Prevent submission if value is not selected
    }

    const filterData = props.filterData ? props.filterData : [];
    const newfilterData = [...filterData];
    const index = newfilterData.findIndex(
      (element) => element.column_name == formValues.column_name.value
    );
    
    // For select types, formValues.column_value is an object with {value, label}
    // For other types, it's just the value
    const isSelectType = formValues.column_name.type === "select";
    const displayValue = isSelectType ? formValues.column_value.label : formValues.column_value;
    const filterValue = isSelectType ? formValues.column_value.value : formValues.column_value;
    
    if (index == -1) {
      newfilterData.push({
        key: formValues.column_name.name,
        column_name: formValues.column_name.value,
        values: [displayValue], // Store label for display
        filterValues: [filterValue], // Store actual value for filtering
      });
    } else {
      newfilterData[index].values = [displayValue];
      newfilterData[index].filterValues = [filterValue];
    }
    props.setFilterType("filter");
    props.setFilterData(newfilterData);
    props.setSearchData("");
    try {
      props.setQFName("");
      props.setQFValue("");
    } catch (err) {}

    props.toggle();
  };

  const handleSelectChange = (options) => {
    field.onChange(options?.value);
    setHasValue(false); // Reset hasValue when category changes
    setValue("column_value", ""); // Clear the previous value
  };
  return (
    <DropdownItem
      className="border-0"
      key={"filter-data"}
      tag={"li"}
      toggle={false}
    >
      <Form onSubmit={handleSubmit(onsubmitdata)}>
        <div className="select-column">
          <CustomSelect
            className="basic-single"
            classNamePrefix="select"
            isClearable={true}
            isSearchable={true}
            value={columnsNames.find((element) => {
              return element.value == field.value;
            })}
            onChange={handleSelectChange}
            options={columnsNames}
            placeholder={"Select Category"}
          />
        </div>
        <div className="select-value">
          <FormGroup className="col-lg-12">{column_type}</FormGroup>
        </div>
        <div className="submit-filter">
          {/* {field.value?.type && field.value?.type == "date" ? (
            <button type="submit" className="btn btn-primary-2">
              <i className="fa fa-check"></i>
            </button>
          ) : (
            ""
          )} */}
          <input
            style={{ display: "none" }}
            className="form-control"
            type="submit"
            placeholder="Enter Value"
          />
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button
            type="submit"
            className="btn btn-primary-2"
            style={{ marginRight: "10px" }}
            disabled={!field.value || !hasValue}
          >
            <i className="fa fa-check"></i>
          </button>
          <button
            type="button"
            className="btn btn-primary-2"
            onClick={() => props.toggle()}
          >
            <i className="fa fa-times"></i>
          </button>
        </div>
      </Form>
    </DropdownItem>
  );
};

export default FilterForm;
